import type { ReactElement } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import OnboardingHubCard from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubCard/OnboardingHubCard";
import { StyledOnboardingHubContentBodyWrapper } from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/containers/styles";
import type { OnboardingGoalQuestionType } from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";
import type {
    SidebarHubTaskItem } from "app/pages/sales-intelligence/sub-modules/onboarding/types/SidebarHub";
import {
    SidebarHubTaskStatus,
} from "app/pages/sales-intelligence/sub-modules/onboarding/types/SidebarHub";

import {
    StyledOnboardingHubCardContent,
    StyledOnboardingHubContentBody,
    StyledOnboardingHubContentDescription,
    StyledOnboardingHubContentLink,
    StyledOnboardingHubContentText,
    StyledOnboardingTaskImage,
    StyledOnboardingTaskImageWrapper,
} from "./styles";

export interface OnboardingHubTasksProps {
    tasks: SidebarHubTaskItem[];
    onTaskActionClick: (task: SidebarHubTaskItem) => void;
    expandedType?: OnboardingGoalQuestionType | null;
    handleTaskState: (
        isExpand: boolean,
        taskType: OnboardingGoalQuestionType,
        isInSidebar?: boolean,
        taskNumber?: number,
    ) => void;
}

const OnboardingHubTasks = ({
    tasks,
    onTaskActionClick,
    expandedType,
    handleTaskState,
}: OnboardingHubTasksProps): ReactElement => {
    return (
        <StyledOnboardingHubContentBodyWrapper>
            <I18n
                translatable={{ key: "si.onboarding.hub.description" }}
                element={StyledOnboardingHubContentDescription}
            />

            <StyledOnboardingHubContentBody>
                {tasks.map((task) => (
                    <OnboardingHubCard
                        key={task.taskType}
                        isExpanded={expandedType === task.taskType ? task.status !== SidebarHubTaskStatus.Completed : null}
                        isDone={task.status === SidebarHubTaskStatus.Completed}
                        title={translate(`si.onboarding.hub.card.title.${task.taskType}`)}
                        onExpand={(isExpand) => handleTaskState(isExpand, task.taskType)}
                        onNavigate={() => onTaskActionClick(task)}
                    >
                        <StyledOnboardingHubCardContent>
                            <StyledOnboardingTaskImageWrapper>
                                <StyledOnboardingTaskImage taskType={task.taskType} />
                            </StyledOnboardingTaskImageWrapper>

                            <I18n
                                translatable={{ key: `si.onboarding.hub.card.description.${task.taskType}` }}
                                element={StyledOnboardingHubContentText}
                            />

                            <StyledOnboardingHubContentLink onClick={() => onTaskActionClick(task)}>
                                <span>{translate("si.onboarding.hub.card.link-button")}</span>
                                <SWReactIcons
                                    iconName="arrow-right"
                                    size="xs"
                                    iconColor={colorsPalettes.blue[400]}
                                />
                            </StyledOnboardingHubContentLink>
                        </StyledOnboardingHubCardContent>
                    </OnboardingHubCard>
                ))}
            </StyledOnboardingHubContentBody>
        </StyledOnboardingHubContentBodyWrapper>
    );
};

export default OnboardingHubTasks;
